/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type FamilyColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const FamilyColorable = ({ color, ...props }: FamilyColorableProps) => {
  const gradientId = useMemo(
    () => `family_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Family', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(9.35, 10.35)" stroke="#F7F5F8" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M26.9364 17.05C27.646 17.0416 28.6514 16.4743 28.65 15.7845V8.08592C28.6494 7.39361 28.0986 6.59305 27.3971 6.38214C24.983 5.67259 22.4098 5.67259 19.9952 6.38214C19.2947 6.59255 18.7428 7.39513 18.7423 8.08592V15.7845" />
        <path d="M9.47663 9.44995L11.8503 16.2358L9.26572 17.0499" />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.1581 15.6499C16.1581 16.4229 15.4833 17.05 14.6509 17.05C13.8174 17.05 13.1427 16.4229 13.1427 15.6499C13.1427 14.8769 13.8174 14.25 14.6509 14.25C15.4833 14.25 16.1581 14.8769 16.1581 15.6499Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.7115 23.05H17.0192V18.65H12.7115V23.05Z" />
        <path d="M10.5577 16.65L12.2808 18.65" />
        <path d="M17.4498 18.65L19.1729 16.65" />
        <path d="M13.3581 23.05V26.65" />
        <path d="M16.3727 23.05V26.65" />
        <path d="M3.66562 22.25C3.8333 23.7165 4.00068 25.1835 4.16864 26.65H6.60818C6.77614 25.1835 6.94352 23.7165 7.11178 22.25" />
        <path d="M23.696 18.25V26.65" />
        <path d="M20.8961 9.04999V26.25H26.4961V9.04999" />
        <path d="M23.696 18.25V26.65" />
        <path d="M9.26539 9.68793C9.03243 8.99508 8.40029 8.19182 7.90456 7.98219C7.03378 7.62738 6.26604 7.45049 5.49722 7.44998H5.49559C4.72759 7.45049 3.95877 7.62738 3.08826 7.98219C2.59307 8.19233 1.95984 8.99635 1.72743 9.68793C1.36784 10.8102 1.00905 11.933 0.65 13.0558C1.00905 14.1783 1.44946 15.5272 1.80879 16.65" />
        <path d="M3.48609 9.84996C2.68446 13.5835 1.88283 17.3167 1.08066 21.05H10.1268C9.32492 17.3167 8.52357 13.5835 7.72194 9.84996" />
        <path fillRule="evenodd" clipRule="evenodd" d="M26.0655 3.05C26.0655 4.37556 24.9084 5.45 23.4814 5.45C22.0528 5.45 20.8962 4.37556 20.8962 3.05C20.8962 1.72444 22.0528 0.65 23.4814 0.65C24.9084 0.65 26.0655 1.72444 26.0655 3.05Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.97304 4.65001C7.97304 5.97535 6.81618 7.05001 5.3887 7.05001C3.96095 7.05001 2.80381 5.97535 2.80381 4.65001C2.80381 3.32466 3.96095 2.25001 5.3887 2.25001C6.81618 2.25001 7.97304 3.32466 7.97304 4.65001Z" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="2.5" x2="44.5" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FamilyColorable;
